// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.designed-button[data-v-7c02c640] {\n  background-color: var(--7c02c640-colorCode);\n  border-radius: 50%;\n  /*width: v-bind(width);*/\n  /*height: v-bind(height);*/\n  min-height: var(--7c02c640-width);\n  min-width: var(--7c02c640-width);\n}\n", ""]);
// Exports
module.exports = exports;
